import { Button } from '@afterpaytouch/core'
import React, { FunctionComponent, ReactNode } from 'react'
import { Route, useRoutePageName } from '../../config/router'
import { pressedPageReturnEventName } from '../../model/monitoring'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { useAppRouter } from '../../state'

interface BackButtonProps {
  route: Route
  onClick?: () => void
  children?: ReactNode
}

export const BackButton: FunctionComponent<BackButtonProps> = ({ route, onClick, children }) => {
  const router = useAppRouter()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const fromPage = useRoutePageName()

  const testNameSpace = route.replace(/\//, '').replace(/\//g, '-')

  const handleClick = (): void => {
    onClick?.()
    logEvent(pressedPageReturnEventName(fromPage))
    router.push(route)
  }

  return (
    <Button.Ghost padding='Fluid' onClick={handleClick} testNameSpace={testNameSpace} data-dd-action-name={`Back To ${testNameSpace} Button`}>
      {children}
    </Button.Ghost>
  )
}
